import axios  from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const MissionSummaryService = {
    async getMissionData(mission_id, agenda_id  = null){
            try{
                let url = `${apiUrl}/MissionSummary/?mission_planning_id=${mission_id}`;
                if (agenda_id) {
                    url += `&mission_planning_agenda_id=${agenda_id}`;
                }
                const response = await axios.get(url);
                return response.data;
            } catch (error) {
                console.error("Error fetching mission data:", error);
                throw error;
            }
        }
};

export default MissionSummaryService;